<template>
  <section :ref="'formAlign'" :refs="'formAlign'">
    <div class="align">
      <h1 v-if="systemFormVuex.currentFormScreen != 'scrEnd'">Сэкономьте время и заполните заявку на займ прямо сейчас</h1>
      <div id="formRouterWrap">
        <frstStep    v-if="systemFormVuex.currentFormScreen == 'frstStep'"></frstStep>
        <confirmSms  v-if="systemFormVuex.currentFormScreen == 'confirmSms'"></confirmSms>
        <fio         v-if="systemFormVuex.currentFormScreen == 'fio'"></fio>
        <passport    v-if="systemFormVuex.currentFormScreen == 'passport'"></passport>
        <srcContact  v-if="systemFormVuex.currentFormScreen == 'srcContact'"></srcContact>
        <scrEnd      v-if="systemFormVuex.currentFormScreen == 'scrEnd'"></scrEnd>
        <scrEndError v-if="systemFormVuex.currentFormScreen == 'scrEndError'"></scrEndError>
        <loader      v-if="systemFormVuex.loading"></loader>
      </div>
    </div>
  </section>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: "formWrap",
    components:{
      frstStep:   () => import('@/components/form/frstSteplnd'),
      loader:     () => import('@/components/chunk/loader'),
      confirmSms: () => import('@/components/form/confirmSms'),
      fio:        () => import('@/components/form/fio'),
      passport:   () => import('@/components/form/passport'),
      srcContact: () => import('@/components/form/scrContact'),
      scrEnd:     () => import('@/components/form/scrEnd'),
      scrEndError:() => import('@/components/form/scrEndScoringError'),
    },
    computed:{ ...mapState({ systemFormVuex: state => state.Form.system, }) },
  }
</script>

<style scoped>
  /deep/.info{ font-size: 4.3vw; padding:1.5vw  3vw 0; }
  /deep/.inputsCollection{}
  /deep/.inputsCollection .inputs2{}
  /deep/.inputsCollection .inputs1{}
  /deep/form{background: white;}
  /deep/.formStepTitle{ font-size: 6.9vw; font-weight: bold; padding: 9.4vw 0;}
  /deep/.formStepTitle span{ color:#0D5A44; }
  #formRouterWrap{ position: relative; }
  /deep/.errorMsg{ color:red; }
  section{ background: #F9F9F8; }
  @media screen and ( min-width: 760px ) {
    h1{ width: 70%; padding-bottom: 2vw; }
    /deep/.info{ font-size: 1.1vw; padding-bottom: 2vw; padding-left: 1.1vw; }
    /deep/.inputsCollection{ display: flex; align-items: flex-start; justify-content: space-between; }
    /deep/.inputsCollection .inputs2{ width: 39vw; }
    /deep/.inputsCollection .inputs1{ width: 39vw; }
    /deep/form{ padding: 2.7vw 5.7vw 0; width: 78.6vw; }
    /deep/.formStepTitle{ font-size: 2vw; padding: 0 0 2.5vw 0;}
    section{ padding-bottom: 4vw; }
  }
  @media screen and (min-width: 1140px) {
    h1 { padding-bottom: 28px; }
    /deep/.info{ font-size: 12px; padding: 5px 13px; }
    /deep/.inputsCollection{}
    /deep/.inputsCollection .inputs2{ width: 444px; }
    /deep/.inputsCollection .inputs1{ width: 444px; }
    /deep/form{ padding: 30px 64px 0; width: 896px; }
    /deep/.formStepTitle{ font-size: 22px; padding: 30px 0; }
    section{ padding-bottom: 50px; }
  }
</style>
